import { createContext, useContext, useMemo, useState } from 'react';

const initialState = {
  source: null,
};

export const FarmSourceContext = createContext({ ...initialState });

export const FarmSourceContextProvider = ({ children }) => {
  const [source, setSource] = useState(initialState.source);
  const value = useMemo(() => ({ source, setSource }), [source]);

  return (
    <FarmSourceContext.Provider value={value}>
      {children}
    </FarmSourceContext.Provider>
  );
};

export const useFarmSourceContext = () => useContext(FarmSourceContext);
